import { render, staticRenderFns } from "./quotes-block-knowledge.vue?vue&type=template&id=2186a511&scoped=true"
var script = {}
import style0 from "./quotes-block-knowledge.vue?vue&type=style&index=0&id=2186a511&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2186a511",
  null
  
)

export default component.exports